import { withStyles } from '@material-ui/core';

import MainPageTopBar from './component';
import styles from './styles';

export default withStyles(styles)(MainPageTopBar);
